import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ColorPicker } from 'wix-rich-content-plugin-commons';
import { getSelectionStyles, Modifier, EditorState } from 'wix-rich-content-editor-common';
import { DEFAULT_STYLE_SELECTION_PREDICATE } from '../constants.js';
import { getColor } from '../text-decorations-utils.js';
import { validateColorScheme, extractColor, extractPalette, extractSchemeAttributes } from '../color-scheme-utils.js';
import 'wix-rich-content-common';
import '../types.js';
import 'lodash';

class TextColorPanel extends Component {
  constructor(props) {
    super(props);
    this.styleSelectionPredicate = props.predicate(
      props.settings.styleSelectionPredicate || DEFAULT_STYLE_SELECTION_PREDICATE
    );
    if (props.settings.colorScheme && !validateColorScheme(props.settings.colorScheme)) {
      console.error("Error: colorScheme is not valid");
    }
    this.currentColors = getSelectionStyles(props.editorState, this.styleSelectionPredicate);
    this.state = {
      currentColor: this.currentColors.length > 0 ? extractColor(props.settings.colorScheme, getColor(this.currentColors[0])) : this.props.defaultColor,
      currentSchemeColor: this.currentColors[0] && getColor(this.currentColors[0]),
      userColors: props.settings.getUserColors() || []
    };
    this.setColor = this.setColor.bind(this);
    this.onColorAdded = this.onColorAdded.bind(this);
  }
  componentWillUnmount() {
    this.props.setKeepToolbarOpen(false);
  }
  setColor({ color: colorName } = {}) {
    let { editorState, settings, defaultColor, onSelect, styleMapper, predicate } = this.props;
    const newColorHex = colorName && extractColor(settings.colorScheme, colorName);
    editorState = getInlineColorState(colorName, editorState, settings, styleMapper, predicate);
    this.setState({
      currentColor: newColorHex || defaultColor,
      currentSchemeColor: colorName || this.currentColors[0] && getColor(this.currentColors[0])
    });
    this.props.closeModal(editorState);
    onSelect && onSelect(colorName);
  }
  onColorAdded({ color }) {
    this.props.settings.onColorAdded(color);
    this.setState({
      userColors: this.props.settings.getUserColors() || []
    });
  }
  render() {
    const { theme, settings, t, setKeepToolbarOpen, isMobile, defaultColor, colorPickerHeaderKey } = this.props;
    const { colorScheme } = settings;
    const palette = extractPalette(colorScheme);
    const schemeAttributes = extractSchemeAttributes(colorScheme);
    const { onCustomPickerToggle, onCustomColorPicked } = settings;
    const paletteColors = isMobile ? palette.slice(0, 5) : palette.slice(0, 6);
    return /* @__PURE__ */ React.createElement(
      ColorPicker,
      {
        schemeAttributes,
        schemeColor: this.state.currentSchemeColor,
        color: this.state.currentColor,
        defaultColor,
        palette: paletteColors,
        userColors: this.state.userColors.slice(0, 17),
        onColorAdded: this.onColorAdded,
        onChange: this.setColor,
        onResetColor: this.setColor,
        onCustomPickerToggle,
        onCustomColorPicked,
        theme,
        t,
        setKeepToolbarOpen,
        isMobile
      },
      ({
        renderPalette,
        renderUserColors,
        renderAddColorButton,
        renderResetColorButton,
        mergedStyles
      }) => /* @__PURE__ */ React.createElement(React.Fragment, null, isMobile && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { className: mergedStyles.colorPicker_header }, t(colorPickerHeaderKey)), /* @__PURE__ */ React.createElement("div", { className: mergedStyles.colorPicker_separator })), /* @__PURE__ */ React.createElement("div", { className: mergedStyles.colorPicker_palette }, /* @__PURE__ */ React.createElement("div", { className: mergedStyles.colorPicker_buttons_container }, renderPalette(), renderUserColors(), isMobile && renderAddColorButton()), !isMobile && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("hr", { className: mergedStyles.colorPicker_separator }), /* @__PURE__ */ React.createElement("div", { className: mergedStyles.colorPicker_bottom_container }, renderResetColorButton(), renderAddColorButton()))))
    );
  }
}
TextColorPanel.propTypes = {
  editorState: PropTypes.object.isRequired,
  setEditorState: PropTypes.func.isRequired,
  theme: PropTypes.object.isRequired,
  t: PropTypes.func,
  uiSettings: PropTypes.object,
  settings: PropTypes.shape({
    onColorAdded: PropTypes.func.isRequired,
    colorScheme: PropTypes.object,
    getUserColors: PropTypes.func,
    onCustomPickerToggle: PropTypes.func,
    onCustomColorPicked: PropTypes.func,
    styleSelectionPredicate: PropTypes.func
  }).isRequired,
  setKeepToolbarOpen: PropTypes.func,
  closeModal: PropTypes.func.isRequired,
  isMobile: PropTypes.bool.isRequired,
  styleMapper: PropTypes.func.isRequired,
  predicate: PropTypes.func,
  defaultColor: PropTypes.string.isRequired,
  onSelect: PropTypes.func,
  colorPickerHeaderKey: PropTypes.string
};
const getInlineColorState = (color, editorState, settings, styleMapper, predicate) => {
  const styleSelectionPredicate = predicate(
    settings && settings.styleSelectionPredicate || DEFAULT_STYLE_SELECTION_PREDICATE
  );
  const selection = editorState.getSelection();
  const currentColors = getSelectionStyles(editorState, styleSelectionPredicate);
  const newEditorState = currentColors.reduce((nextEditorState, prevColor) => {
    const contentState2 = nextEditorState.getCurrentContent();
    const nextContentState = Modifier.removeInlineStyle(contentState2, selection, prevColor);
    return EditorState.push(nextEditorState, nextContentState, "change-inline-style");
  }, editorState);
  let contentState = newEditorState.getCurrentContent();
  if (color) {
    contentState = Modifier.applyInlineStyle(contentState, selection, styleMapper(color));
  }
  return EditorState.push(newEditorState, contentState, "change-inline-style");
};

export { TextColorPanel as default, getInlineColorState };
//# sourceMappingURL=TextColorPanel.js.map
